import React from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import SVG from '../SVG';
import { Colours } from '../../tokens';
const useStyles = createUseStyles({
    root: {
        color: Colours.primary,
    },
});
const BackArrowIcon = ({ className }) => {
    const styles = useStyles();
    return (React.createElement(SVG, { width: "16", height: "16", viewBox: "0 0 16 16", className: classNames(styles.root, className) },
        React.createElement("g", { transform: "translate(-620 -252)" },
            React.createElement("g", { transform: "translate(620 252)" },
                React.createElement("path", { d: "M6,0H4.667C1.333,0,0,1.333,0,4.667v4C0,12,1.333,13.334,4.667,13.334h4c3.334,0,4.667-1.333,4.667-4.667V7.334", transform: "translate(1.333 1.333)", fill: "none", stroke: "#222239", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
                React.createElement("path", { d: "M5.992.847.74,6.1a1.808,1.808,0,0,0-.44.88L.014,8.984a.949.949,0,0,0,1.133,1.133L3.153,9.83a1.867,1.867,0,0,0,.88-.44L9.284,4.139a2.024,2.024,0,0,0,0-3.292A2.024,2.024,0,0,0,5.992.847Z", transform: "translate(4.704 1.165)", fill: "none", stroke: "#222239", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
                React.createElement("path", { d: "M0,0A4.761,4.761,0,0,0,3.292,3.292", transform: "translate(9.941 2.767)", fill: "none", stroke: "#222239", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
                React.createElement("path", { d: "M0,0H16V16H0Z", fill: "none", opacity: "0" })))));
};
export default BackArrowIcon;
//# sourceMappingURL=EditIcon.js.map